import Swiper from 'swiper/dist/js/swiper.min.js';
import MicroModal from 'micromodal';

export default {
    init() {
        // JavaScript to be fired on the about us page

        MicroModal.init({
            disableScroll: false,
            disableFocus: true,
            awaitCloseAnimation: true,
        });

        $('.bundle__content .scroll-hint').on('click', function(e) {
          e.preventDefault();
          $('html, body').animate(
            {
              scrollTop: $(this).parent().find('.modal__cell--left').offset().top - 100,
            },
            1500
          );
        });

        var swiperInstances = [];
        $('.swiper-container').each(function(index){
            let $this = $(this);
            $this.addClass('instance-' + index);
            $this.find('.swiper-button-prev').addClass('btn-prev-' + index);
            $this.find('.swiper-button-next').addClass('btn-next-' + index);
            let swiper = new Swiper('.instance-' + index, {
                // your settings ...
                nextButton: '.btn-next-' + index,
                prevButton: '.btn-prev-' + index,
                on: {
                    click: function (event) {
                      /* do something */
                      document.querySelector('.modal--viewbox .image').style.backgroundImage = event.target.style.backgroundImage;

                      MicroModal.show('modal-viewbox', {
                        awaitCloseAnimation: true,
                        disableScroll: true,
                      });
                    },
                },
            });

            swiperInstances.push(swiper);
        });

        // Now you can call the update on a specific instance in the 'swiperInstances' object
        // e.g.
        // swiperInstances[3].update();

        $('.tabs').on('change.zf.tabs', function() {
            swiperInstances.forEach(function(swiperInstance) {
                swiperInstance.update();
            });
        });
    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/templateInteriordesign.js